import _ from 'lodash';
import { connect } from 'react-redux';

import ServiceLoginPreview from 'app/explore/components/ServiceLoginPreview';
import { selectServicesFromSlugsWithZapier } from 'app/explore/Selectors';
import { withPublicSearchableServicesData } from 'app/service/components/WithPublicSearchableServicesData';

const mapStateToProps = (state, props) => {
  return {
    services: selectServicesFromSlugsWithZapier(state, props),
  };
};

export default _.flowRight(
  withPublicSearchableServicesData,
  connect(mapStateToProps)
)(ServiceLoginPreview);
